import {
  Avatar,
  Box,
  Card,
  Chip,
  Divider,
  Grid,
  Typography,
  LinearProgress,
  CircularProgress,
  Button,
  Tooltip,
  useTheme,
  Checkbox,
  ToggleButton,
  ToggleButtonGroup,
  Menu,
  MenuItem,
  IconButton,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AgGridTable from "../../components/table/AgGridTable";
import { ColDef } from "ag-grid-community";
import Exclamation from "../../assets/Exclamation.png";
import sparkLogo from "../../assets/Spark-text.svg";
//import csiLogo from '../../assets/cis.png';
import csiLogo from "../../assets/cis_light.svg";
import nistLogo from "../../assets/nist.svg";
import nist_dark from "../../assets/nist_dark.svg";
import spark_dark from "../../assets/spark_dark.svg";
import cis_dark from "../../assets/cis_dark.svg";
import True from "../../assets/baseVersion/True_img.svg";
import False from "../../assets/baseVersion/False_img.svg";
import Not_Applicable from "../../assets/baseVersion/NotApplicable.svg";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import DrawerWrapper from "../../components/drawer/Drawer";
import RiskDetailsDrawer from "./RiskDetailsDrawer";
import axiosInstance from "../../axios/axios";
import { END_POINTS } from "../../shared";
import RiskHistoryDrawer from "./RiskHistoryDrawer";
import SeeDetailsDrawer from "./SeeDetailsDrawer";
import { SkeletonLoader } from "../../modules/dashboard/shared";
import AcceptedRisk_False from "../../assets/baseVersion/AcceptedRisk_False.svg";
import eventEmitter from "../../components/utils/eventEmitter";
import useRolePermissions from "../../shared/hooks/useRolePermissions";
import { ROLES_CONTENT_PROPS } from "../../shared/constants/constant-data";
import {
  setButtonSelected,
  setCategorySelected,
  setSelectedControlType,
  setSelectedRowID,
} from "../SecurityPosture/TabSelection-slice";
// Custom checkbox filter for Benchmark column
const BenchmarkFilter = React.forwardRef<any, any>((params, ref) => {
  const [selected, setSelected] = useState<string[]>([]);
  const [isAll, setIsAll] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const [options, setOptions] = useState<string[]>(Array.isArray(params.benchmarks) ? params.benchmarks : []);

  const filteredOptions = useMemo(() => {
    const opts = options || [];
    if (!searchText.trim()) return opts;
    return opts.filter((o) => o.toLowerCase().includes(searchText.toLowerCase()));
  }, [options, searchText]);

  React.useEffect(() => {
    if (Array.isArray(params.benchmarks)) {
      setOptions(params.benchmarks);
    }
  }, [params.benchmarks]);

  React.useImperativeHandle(ref, () => ({
    isFilterActive: () => selected.length > 0 && !isAll,
    doesFilterPass: (nodeParams: any) => {
      if (selected.length === 0 || isAll) return true;
      const val = nodeParams.data?.control_type;
      if (val == null) return false;
      const rowUpper = String(val).toUpperCase().trim();
      return selected.some((s) => rowUpper === String(s).toUpperCase().trim());
    },
    getModel: () => (selected.length > 0 && !isAll ? { selectedTypes: selected } : null),
    setModel: (model: any) => {
      if (model && model.selectedTypes) {
        setSelected(model.selectedTypes);
        setIsAll(false);
      } else {
        setSelected([]);
        setIsAll(true);
      }
    },
    afterGuiAttached: () => { },
    getGui: () => null,
  }));

  const toggleOption = (opt: string) => {
    if (opt === "All") {
      setIsAll(true);
      setSelected([]);
    } else {
      setIsAll(false);
      setSelected((prev) => (prev.includes(opt) ? prev.filter((o) => o !== opt) : [...prev, opt]));
    }
    // mark as modified
    // @ts-ignore
    if (typeof (params as any).filterModifiedCallback === "function") (params as any).filterModifiedCallback();
  };

  const apply = () => {
    console.log("BenchmarkFilter Apply clicked", { selected, isAll });
    try {
      if (typeof (params as any).onApplyBenchmarkFilter === 'function') {
        (params as any).onApplyBenchmarkFilter(selected, isAll);
      }
    } catch { }
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function") (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const clear = () => {
    setSelected([]);
    setIsAll(true);
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function") (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const isDarkTheme = params.isDarkMode || false;

  return (
    <div style={{ padding: "12px", minWidth: "240px", backgroundColor: isDarkTheme ? "#2d3748" : "#ffffff", border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`, borderRadius: "6px", boxShadow: isDarkTheme ? "0 4px 6px rgba(0, 0, 0, 0.3)" : "0 4px 6px rgba(0, 0, 0, 0.1)", fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', fontSize: "13px" }}>
      <div style={{ marginBottom: "12px", fontWeight: "500", color: isDarkTheme ? "#f7fafc" : "#2d3748", fontSize: "13px" }}>Filter Benchmarks</div>
      <div style={{ marginBottom: "12px" }}>
        <input type="text" placeholder="Search..." value={searchText} onChange={(e) => setSearchText(e.target.value)} style={{ width: "100%", padding: "6px 8px", border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`, borderRadius: "4px", backgroundColor: isDarkTheme ? "#1a202c" : "#ffffff", color: isDarkTheme ? "#f7fafc" : "#2d3748", fontSize: "13px", outline: "none", boxSizing: "border-box" }} />
      </div>
      <div style={{ maxHeight: "200px", overflowY: "auto", marginBottom: "12px" }}>
        <div style={{ display: "flex", alignItems: "center", padding: "1px 8px", cursor: "pointer", backgroundColor: isAll ? (isDarkTheme ? "#3182ce" : "#e2e8f0") : "transparent", borderRadius: "4px", marginBottom: "2px" }}>
          <Checkbox size="small" checked={isAll} onChange={() => toggleOption("All")} sx={{ color: isDarkTheme ? "#a0aec0" : undefined, "&.Mui-checked": { color: isDarkTheme ? "#90CAF9" : "#3182ce" } }} />
          <span style={{ marginLeft: 8, color: isDarkTheme ? "#f7fafc" : "#2d3748" }}>All</span>
        </div>
        {filteredOptions.map((opt) => {
          const checked = !isAll && selected.includes(opt);
          return (
            <div key={opt} style={{ display: "flex", alignItems: "center", padding: "6px 8px", cursor: "pointer", backgroundColor: checked ? (isDarkTheme ? "#3182ce" : "#e2e8f0") : "transparent", borderRadius: "4px", marginBottom: 2 }}>
              <Checkbox size="small" checked={checked} onChange={() => toggleOption(opt)} sx={{ color: isDarkTheme ? "#a0aec0" : undefined, "&.Mui-checked": { color: isDarkTheme ? "#90CAF9" : "#3182ce" } }} />
              <span style={{ marginLeft: 8, color: isDarkTheme ? "#f7fafc" : "#2d3748" }}>{opt}</span>
            </div>
          );
        })}
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button onClick={clear} style={{ padding: "6px 12px", backgroundColor: isDarkTheme ? "#4a5568" : "#e2e8f0", color: isDarkTheme ? "#f7fafc" : "#2d3748", border: "none", borderRadius: 4, cursor: "pointer", fontSize: 13 }}>Clear</button>
        <button onClick={apply} style={{ padding: "6px 12px", backgroundColor: "#0969da", color: "white", border: "none", borderRadius: 4, cursor: "pointer", fontSize: 13 }}>Apply</button>
      </div>
    </div>
  );
});

// Custom checkbox filter for Severity column
const SeverityFilter = React.forwardRef<any, any>((params, ref) => {
  const [selected, setSelected] = React.useState<string[]>([]);
  const [isAll, setIsAll] = React.useState<boolean>(false);
  const [searchText, setSearchText] = React.useState<string>("");
  const [options, setOptions] = React.useState<string[]>(Array.isArray(params.severities) ? params.severities : []);

  const filteredOptions = React.useMemo(() => {
    const opts = options || [];
    if (!searchText.trim()) return opts;
    return opts.filter((o) => o.toLowerCase().includes(searchText.toLowerCase()));
  }, [options, searchText]);

  React.useEffect(() => {
    if (Array.isArray(params.severities)) setOptions(params.severities);
  }, [params.severities]);

  React.useImperativeHandle(ref, () => ({
    isFilterActive: () => selected.length > 0 && !isAll,
    doesFilterPass: (nodeParams: any) => {
      if (selected.length === 0 || isAll) return true;
      const val = nodeParams.data?.highest_priority;
      if (val == null) return false;
      const rowUpper = String(val).toUpperCase().trim();
      return selected.some((s) => rowUpper === String(s).toUpperCase().trim());
    },
    getModel: () => (selected.length > 0 && !isAll ? { selectedTypes: selected } : null),
    setModel: (model: any) => {
      if (model && model.selectedTypes) {
        setSelected(model.selectedTypes);
        setIsAll(false);
      } else {
        setSelected([]);
        setIsAll(true);
      }
    },
    afterGuiAttached: () => {},
    getGui: () => null,
  }));

  const toggle = (opt: string) => {
    if (opt === "All") {
      setIsAll(true);
      setSelected([]);
    } else {
      setIsAll(false);
      setSelected((prev) => (prev.includes(opt) ? prev.filter((o) => o !== opt) : [...prev, opt]));
    }
    // @ts-ignore
    if (typeof (params as any).filterModifiedCallback === 'function') (params as any).filterModifiedCallback();
  };

  const apply = () => {
    try {
      if (typeof (params as any).onApplySeverityFilter === 'function') {
        (params as any).onApplySeverityFilter(selected, isAll);
      }
    } catch { }
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === 'function') (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const clear = () => {
    setSelected([]);
    setIsAll(true);
    try {
      if (typeof (params as any).onApplySeverityFilter === 'function') {
        (params as any).onApplySeverityFilter([], true);
      }
    } catch { }
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === 'function') (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const isDarkTheme = params.isDarkMode || false;

  return (
    <div style={{ padding: '12px', minWidth: '240px', backgroundColor: isDarkTheme ? '#2d3748' : '#ffffff', border: `1px solid ${isDarkTheme ? '#4a5568' : '#e2e8f0'}`, borderRadius: '6px', boxShadow: isDarkTheme ? '0 4px 6px rgba(0, 0, 0, 0.3)' : '0 4px 6px rgba(0, 0, 0, 0.1)', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', fontSize: '13px' }}>
      <div style={{ marginBottom: '12px', fontWeight: 500, color: isDarkTheme ? '#f7fafc' : '#2d3748', fontSize: '13px' }}>Filter Severity</div>
      <div style={{ marginBottom: '12px' }}>
        <input type="text" placeholder="Search..." value={searchText} onChange={(e) => setSearchText(e.target.value)} style={{ width: '100%', padding: '6px 8px', border: `1px solid ${isDarkTheme ? '#4a5568' : '#e2e8f0'}`, borderRadius: '4px', backgroundColor: isDarkTheme ? '#1a202c' : '#ffffff', color: isDarkTheme ? '#f7fafc' : '#2d3748', fontSize: '13px', outline: 'none', boxSizing: 'border-box' }} />
      </div>
      <div style={{ maxHeight: '200px', overflowY: 'auto', marginBottom: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', padding: '0px 8px', cursor: 'pointer', backgroundColor: isAll ? (isDarkTheme ? '#3182ce' : '#e2e8f0') : 'transparent', borderRadius: '4px', marginBottom: '2px' }}>
          <Checkbox size='small' checked={isAll} onChange={() => toggle('All')} sx={{ color: isDarkTheme ? "#a0aec0" : undefined, "&.Mui-checked": { color: isDarkTheme ? "#90CAF9" : "#3182ce" } }} />
          <span style={{ marginLeft: 8, color: isDarkTheme ? "#f7fafc" : "#2d3748" }}>All</span>
        </div>
        {filteredOptions.map((opt) => {
          const checked = !isAll && selected.includes(opt);
          return (
            <div key={opt} style={{ display: 'flex', alignItems: 'center', padding: '0px 8px', cursor: 'pointer', backgroundColor: checked ? (isDarkTheme ? '#3182ce' : '#e2e8f0') : 'transparent', borderRadius: '4px', marginBottom: 2 }}>
              <Checkbox size='small' checked={checked} onChange={() => toggle(opt)} sx={{ color: isDarkTheme ? "#a0aec0" : undefined, "&.Mui-checked": { color: isDarkTheme ? "#90CAF9" : "#3182ce" } }} />
              <span style={{ marginLeft: 8, color: isDarkTheme ? "#f7fafc" : "#2d3748" }}>{opt}</span>
            </div>
          );
        })}
      </div>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <button onClick={clear} style={{ padding: '6px 12px', backgroundColor: isDarkTheme ? '#4a5568' : '#e2e8f0', color: isDarkTheme ? '#f7fafc' : '#2d3748', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>Clear</button>
        <button onClick={apply} style={{ padding: '6px 12px', backgroundColor: '#0969da', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>Apply</button>
      </div>
    </div>
  );
});

const RiskAcceptancePage = () => {
  const [open, setOpen] = React.useState(false);
  const [isRiskDrawerOpen, setIsRiskDrawerOpen] = React.useState(false);
  const [isSeeDetailsOpen, setIsSeeDetailsOpen] = React.useState(false);
  const [selectedRiskDetails, setSelectedRiskDetails] =
    React.useState<any>(null);
  const [selectedRiskHistory, setSelectedRiskHistory] =
    React.useState<any>(null);
  const [trigger, setTrigger] = useState(0);
  const handleClose = () => setOpen(false);
  const [loading, setIsLoading] = React.useState(false);
  // Risk History has its own flag: gating it on `loading` (the security-info table call) hid
  // already-fetched history behind the skeleton until the slow table query finished.
  const [isHistoryLoading, setIsHistoryLoading] = React.useState(true);
  const [summaryDeatils, setSummaryDetails] = React.useState<any>({});
  const [riskHistoryData, setRiskHistoryData] = React.useState<any[]>([]);
  const [riskDetails, setRiskDetails] = React.useState<any[]>([]);
  const [gridData, setGridData] = React.useState<any[]>([]);
  const [activeBenchmarks, setActiveBenchmarks] = React.useState<string[]>([]);

  const formatDateForBy = (dateStr?: string) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return "";
    const day = String(d.getDate()).padStart(2, "0");
    const monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const month = monthNames[d.getMonth()];
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getRequestedByInfo = (item: any) => {
    const name =
      item?.requested_by_display_name ||
      item?.requested_by_email ||
      (item?.requested_by_first_name || item?.requested_by_last_name
        ? `${item?.requested_by_first_name || ""} ${item?.requested_by_last_name || ""}`.trim()
        : "") ||
      item?.display_name ||
      (item?.first_name || item?.last_name
        ? `${item?.first_name || ""} ${item?.last_name || ""}`.trim()
        : "") ||
      item?.email ||
      "-";

    const rawDate = item?.time || item?.requested_time || item?.created_at;
    const formattedDate = formatDateForBy(rawDate);
    return formattedDate ? `${name} (${formattedDate})` : name;
  };

  const getApprovedByInfo = (item: any) => {
    const name =
      item?.approved_by_display_name ||
      item?.approved_by_email ||
      (item?.approved_by_first_name || item?.approved_by_last_name
        ? `${item?.approved_by_first_name || ""} ${item?.approved_by_last_name || ""}`.trim()
        : "") ||
      "-";

    const rawDate = item?.approved_time || item?.approved_at;
    const formattedDate = formatDateForBy(rawDate);
    return name !== "-" && formattedDate
      ? `${name} (${formattedDate})`
      : name !== "-"
      ? name
      : "-";
  };

  const getRejectedByInfo = (item: any) => {
    const name =
      item?.rejected_by_display_name ||
      item?.rejected_by_email ||
      (item?.rejected_by_first_name || item?.rejected_by_last_name
        ? `${item?.rejected_by_first_name || ""} ${item?.rejected_by_last_name || ""}`.trim()
        : "") ||
      "-";

    const rawDate = item?.rejected_time || item?.rejected_at;
    const formattedDate = formatDateForBy(rawDate);
    return name !== "-" && formattedDate
      ? `${name} (${formattedDate})`
      : name !== "-"
      ? name
      : "-";
  };

  const shouldShowRejectedBy = (item: any) => {
    const hasApproved =
      !!item?.approved_time ||
      (!!item?.approved_by_display_name && item?.approved_by_display_name !== "-") ||
      (!!item?.approved_by_email && item?.approved_by_email !== "-") ||
      !!item?.approved_by_id;

    const hasRejected =
      !!item?.rejected_time ||
      (!!item?.rejected_by_display_name && item?.rejected_by_display_name !== "-") ||
      (!!item?.rejected_by_email && item?.rejected_by_email !== "-") ||
      !!item?.rejected_by_id;

    if (hasApproved && hasRejected) {
      const approvedTime = item?.approved_time ? new Date(item.approved_time).getTime() : 0;
      const rejectedTime = item?.rejected_time ? new Date(item.rejected_time).getTime() : 0;

      if (!isNaN(approvedTime) && !isNaN(rejectedTime) && approvedTime > 0 && rejectedTime > 0) {
        return rejectedTime > approvedTime;
      }
    }

    if (item?.approval_status === "REJECTED") {
      return true;
    }

    if (item?.approval_status === "APPROVED") {
      return false;
    }

    if (hasRejected && !hasApproved) {
      return true;
    }

    return false;
  };

  const isPendingRiskHistory = (item: any) => {
    const status = String(item?.approval_status || "").toUpperCase();
    return status === "PENDING" && !item?.approved_time && !item?.rejected_time;
  };
  const [activeSeverities, setActiveSeverities] = React.useState<string[]>([]);
  const [activeTab, setActiveTab] = useState<"risk_acceptance" | "admin_requests">("risk_acceptance");

  const [adminRequests, setAdminRequests] = useState<any[]>([]);
  const [isAdminRequestsLoading, setIsAdminRequestsLoading] = useState(false);
  const [actionLoadingState, setActionLoadingState] = useState<{
    id: string;
    action: "approve" | "reject";
  } | null>(null);
  const [selectedAdminRequests, setSelectedAdminRequests] = useState<any[]>([]);
  const adminGridRef = React.useRef<any>(null);

  const handleClearAdminSelection = useCallback(() => {
    if (adminGridRef.current?.api) {
      adminGridRef.current.api.deselectAll();
    }
    setSelectedAdminRequests([]);
  }, []);

  useEffect(() => {
    if (selectedAdminRequests.length > 0) {
      const validSelected = selectedAdminRequests.filter((selectedRow) => {
        const selId = String(selectedRow?.id ?? selectedRow?.whitelist_id);
        return adminRequests.some((row) => String(row?.id ?? row?.whitelist_id) === selId);
      });
      if (validSelected.length !== selectedAdminRequests.length) {
        setSelectedAdminRequests(validSelected);
        if (validSelected.length === 0 && adminGridRef.current?.api) {
          adminGridRef.current.api.deselectAll();
        }
      }
    }
  }, [adminRequests]);
  const [bulkActionAnchorEl, setBulkActionAnchorEl] = useState<null | HTMLElement>(null);
  const [isBulkActionLoading, setIsBulkActionLoading] = useState(false);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const { hasPermissions } = useRolePermissions();
  const storedUserDetails = localStorage.getItem("userDetails");
  const parsedUserDetails = useMemo(() => {
    try {
      return storedUserDetails ? JSON.parse(storedUserDetails) : null;
    } catch {
      return null;
    }
  }, [storedUserDetails]);

  const isAdmin = useMemo(() => {
    const roleName = String(
      parsedUserDetails?.role_name ||
      parsedUserDetails?.role ||
      ""
    ).toLowerCase();
    return roleName.includes("admin") || hasPermissions(ROLES_CONTENT_PROPS.MODIFY_RISK_PARAMETER);
  }, [parsedUserDetails, hasPermissions]);

  const isFetchingAdminRequestsRef = React.useRef(false);

  const fetchAdminRequests = React.useCallback(async () => {
    if (isFetchingAdminRequestsRef.current) return;
    isFetchingAdminRequestsRef.current = true;
    try {
      setIsAdminRequestsLoading(true);
      const pageSize = 50;
      const maxPages = 100;
      let page = 1;
      let total = 0;
      const allRequests: any[] = [];

      // Backend paginates at 50; keep requesting until we have the full pending queue.
      do {
        const response = await axiosInstance.get(END_POINTS.WHITELIST_REQUESTS, {
          params: {
            page,
            page_size: pageSize,
          },
        });
        const payload = response?.data?.data;
        const batch = Array.isArray(payload)
          ? payload
          : payload?.results ||
            payload?.whitelist_requests ||
            payload?.requests ||
            [];
        total = Number(payload?.total ?? total) || allRequests.length + batch.length;
        if (!Array.isArray(batch) || batch.length === 0) {
          break;
        }
        allRequests.push(...batch);
        page += 1;
      } while (allRequests.length < total && page <= maxPages);

      setAdminRequests(allRequests);
    } catch (error) {
      console.error("Admin Requests Data Fetch Failed", error);
      setAdminRequests([]);
    } finally {
      setIsAdminRequestsLoading(false);
      isFetchingAdminRequestsRef.current = false;
    }
  }, []);

  const handleApproveReject = async (
    whitelistId: string,
    action: "approve" | "reject"
  ) => {
    if (!whitelistId || actionLoadingState !== null) return;
    try {
      setActionLoadingState({ id: String(whitelistId), action });
      const payload = {
        action: action,
        whitelist_ids: [whitelistId],
      };
      const response = await axiosInstance.post(
        END_POINTS.WHITELIST_APPROVE,
        payload
      );
      handleClearAdminSelection();
      fetchAdminRequests();
      summaryDetails();
      riskHistory();
      riskDetail();
    } catch (error: any) {
      console.error(`Failed to ${action} request`, error);
    } finally {
      setActionLoadingState(null);
    }
  };

  const handleBulkApproveReject = async (action: "approve" | "reject") => {
    setBulkActionAnchorEl(null);
    if (selectedAdminRequests.length === 0 || isBulkActionLoading) return;
    try {
      setIsBulkActionLoading(true);
      const whitelistIds = selectedAdminRequests.map(
        (row: any) => String(row?.id ?? row?.whitelist_id)
      );
      const payload = {
        action: action,
        whitelist_ids: whitelistIds,
      };
      const response = await axiosInstance.post(
        END_POINTS.WHITELIST_APPROVE,
        payload
      );

      handleClearAdminSelection();
      fetchAdminRequests();
      summaryDetails();
      riskHistory();
      riskDetail();
    } catch (error: any) {
      console.error(`Failed to bulk ${action} requests`, error);
    } finally {
      setIsBulkActionLoading(false);
    }
  };

  const handleAdminSelectionChange = useCallback((selectedRows: any[]) => {
    setSelectedAdminRequests(selectedRows);
  }, []);

  const adminGridOptions = useMemo(() => ({
    getRowId: (params: any) =>
      String(
        params.data?.id ??
          params.data?.whitelist_id ??
          params.data?.device_id ??
          params.data?.parameter_name_id ??
          params.node?.rowIndex
      ),
    isRowSelectable: (rowNode: any) => {
      const status = (
        rowNode.data?.approval_status ||
        rowNode.data?.status ||
        "Pending"
      )
        .toString()
        .toLowerCase();
      return (
        !status.includes("approv") &&
        !status.includes("reject") &&
        status !== "1" &&
        status !== "2"
      );
    },
  }), []);

  const summaryDetails = async () => {
    try {
      //setIsLoading(true)
      const response = await axiosInstance.get(
        END_POINTS.RISK_ACCEPTANCE_SUMMARY
      );
      if (response.data?.data?.vulnerability) {
        setSummaryDetails(response.data.data.vulnerability);
      }
    } catch (error) {
      console.error("Schedule Data Fetch Failed", error);
      //setIsLoading(false)
    }
  };

  const riskHistory = async () => {
    try {
      setIsHistoryLoading(true);
      const response = await axiosInstance.get(
        END_POINTS.RISK_ACCEPTANCE_HISTORY
      );
      if (response?.data?.data?.whitelist_data) {
        const sortedHistory = [...response.data.data.whitelist_data].sort(
          (a: any, b: any) => {
            const getLatestActivityTime = (item: any) => {
              const timestamps = [item.rejected_time, item.approved_time, item.time]
                .filter(Boolean)
                .map((value) => new Date(value).getTime())
                .filter((timestamp) => !Number.isNaN(timestamp));

              return timestamps.length > 0 ? Math.max(...timestamps) : 0;
            };

            return getLatestActivityTime(b) - getLatestActivityTime(a);
          }
        );

        setRiskHistoryData(sortedHistory);
      }
    } catch (error) {
      console.error("Risk History Data Fetch Failed", error);
    } finally {
      setIsHistoryLoading(false);
    }
  };

  const riskDetail = async () => {
    try {
      setIsLoading(true);
      
      const [onPremiseResponse, cloudResponse] = await Promise.all([
        axiosInstance.get(END_POINTS.RISK_ACCEPTANCE_TABLE, { params: { module: "on_premise" } }),
        axiosInstance.get(END_POINTS.RISK_ACCEPTANCE_TABLE, { params: { module: "cloud" } })
      ]);

      const onPremiseData = Array.isArray(onPremiseResponse?.data?.data) ? onPremiseResponse.data.data.map((i: any) => ({...i, module: "on_premise"})) : [];
      const cloudData = Array.isArray(cloudResponse?.data?.data) ? cloudResponse.data.data.map((i: any) => ({...i, module: "cloud"})) : [];
      
      const combinedData = [...onPremiseData, ...cloudData];
      const filteredData = combinedData.filter((item: any) => item.parameter_type !== "Template");
      const mappedData = filteredData.map((item: any) => {
        const passedCount = item.passed_asset_count;
        const totalCount = item.total_asset_count;
        const progressValue = Math.round(item.asset_passed_percent) || 0;
        return {
          ...item,
          compliance_count: item.asset_passed_percent,
          total_Count: item.total_asset_count,
          failed_asset_count: item.failed_asset_count,
          passed_asset_count: item.passed_asset_count,
          not_applicable_asset_count: item.not_applicable_asset_count,
        };
      });
      const sortedData = [...mappedData].sort(
        (a: any, b: any) => (b.accepted_count || 0) - (a.accepted_count || 0)
      );
      setRiskDetails(sortedData);
    } catch (error) {
      console.error("Risk Details Data Fetch Failed", error);
    } finally {
      setIsLoading(false);
    }
  };
  const uniqueBenchmarks = useMemo<string[]>(() => {
    const set = new Set<string>();
    riskDetails.forEach((row: any) => {
      const val = row?.control_type;
      if (val) set.add(String(val).toUpperCase());
    });
    return Array.from(set);
  }, [riskDetails]);

  const uniqueSeverities = useMemo<string[]>(() => {
    const set = new Set<string>();
    riskDetails.forEach((row: any) => {
      const val = row?.highest_priority;
      if (val) set.add(String(val).toUpperCase());
    });
    return Array.from(set);
  }, [riskDetails]);

  const applyAllFilters = useCallback((bench: string[], sev: string[], sourceData: any[]) => {
    const benchTargets = (bench || []).map((s) => String(s).toUpperCase().trim());
    const sevTargets = (sev || []).map((s) => String(s).toUpperCase().trim());
    const filtered = (sourceData || []).filter((row: any) => {
      const rowBench = String(row?.control_type ?? "").toUpperCase().trim();
      const rowSev = String(row?.highest_priority ?? "").toUpperCase().trim();
      const benchOk = benchTargets.length === 0 || benchTargets.includes(rowBench);
      const sevOk = sevTargets.length === 0 || sevTargets.includes(rowSev);
      return benchOk && sevOk;
    });
    setGridData(filtered);
  }, []);

  const applyBenchmarkFilter = useCallback((selected: string[], isAll: boolean) => {
    const next = isAll ? [] : (selected || []);
    setActiveBenchmarks(next);
    applyAllFilters(next, activeSeverities, riskDetails);
  }, [applyAllFilters, activeSeverities, riskDetails]);

  const applySeverityFilter = useCallback((selected: string[], isAll: boolean) => {
    const next = isAll ? [] : (selected || []);
    setActiveSeverities(next);
    applyAllFilters(activeBenchmarks, next, riskDetails);
  }, [applyAllFilters, activeBenchmarks, riskDetails]);

  useEffect(() => {
    const handleFilterSaved = () => {
      setIsLoading(true);
      setTrigger((prev) => prev + 1); // Changing this will re-trigger the effect
    };

    const handleCloseAllDrawers = () => {
      setOpen(false);
      setIsRiskDrawerOpen(false);
      setIsSeeDetailsOpen(false);
    };

    eventEmitter.on("filterSaved", handleFilterSaved);
    eventEmitter.on("closeAllDrawers", handleCloseAllDrawers);

    return () => {
      eventEmitter.off("filterSaved", handleFilterSaved);
      eventEmitter.off("closeAllDrawers", handleCloseAllDrawers);
    };
  }, []);

  useEffect(() => {
    summaryDetails();
    riskHistory();
    riskDetail();
  }, [trigger]);

  useEffect(() => {
    if (activeTab === "admin_requests" && isAdmin) {
      fetchAdminRequests();
    }
  }, [activeTab, isAdmin, fetchAdminRequests]);

  useEffect(() => {
    if (activeTab === "risk_acceptance") {
      applyAllFilters(activeBenchmarks, activeSeverities, riskDetails);
    }
  }, [activeTab, applyAllFilters, activeBenchmarks, activeSeverities, riskDetails]);

  const columnDefs: ColDef[] = useMemo(() => [
    {
      field: "id",
      headerName: "#",
      width: 70,
      maxWidth: 75,
      minWidth: 60,
      filter: false,
      sortable: false,
      suppressMenu: true,
      valueGetter: (params: any) => params.node.rowIndex + 1,
    },
    {
      field: "param_name",
      headerName: "Recommendation",
      flex: 1.2,
      minWidth: 220,

      cellRenderer: (params: any) => {
        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              width: "100%",
            }}
          >
            <Tooltip
              title={params.data?.param_name || ""}
              slotProps={{
                popper: {
                  sx: {
                    "& .MuiTooltip-tooltip": {
                      backgroundColor: "#fff",
                      color: "#000",
                      fontSize: "0.75rem",
                      border: "1px solid #ddd",
                      boxShadow: 2,
                    },
                  },
                },
              }}
            >
              <Typography
                noWrap
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  width: "100%",
                }}
              >
                {params.value}
              </Typography>
            </Tooltip>
          </Box>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "control_type",
      headerName: "Benchmark",
      width: 200,
      filter: BenchmarkFilter,
      filterParams: {
        benchmarks: uniqueBenchmarks,
        isDarkMode: isDarkMode,
        onApplyBenchmarkFilter: applyBenchmarkFilter,
      },
      cellRenderer: (params: any) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, pt: 1 }}>
          {params.value?.includes("SPARK") && (
            <img
              src={isDarkMode ? spark_dark : sparkLogo}
              alt="spark"
              height="24"
            />
          )}
          {params.value?.includes("CIS") && (
            <img src={isDarkMode ? cis_dark : csiLogo} alt="cis" height="24" />
          )}
          {params.value?.includes("NIST") && (
            <img
              src={isDarkMode ? nist_dark : nistLogo}
              alt="nist"
              height="12"
            />
          )}
        </Box>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "highest_priority",
      headerName: "Severity",
      width: 150,
      filter: SeverityFilter,
      filterParams: {
        severities: uniqueSeverities,
        isDarkMode: isDarkMode,
        onApplySeverityFilter: applySeverityFilter,
      },
      cellRenderer: (params: any) => {
        const severityStyles: any = {
          Critical: { bgcolor: isDarkMode ? "rgba(255, 61, 61, 0.18)" : "#67000424", color: isDarkMode ? "#FF3D3D" : "#670004" },
          High: { bgcolor: isDarkMode ? "rgba(255, 107, 107, 0.15)" : "#A7000F24", color: isDarkMode ? "#FF6B6B" : "#A7000F" },
          Medium: { bgcolor: isDarkMode ? "rgba(255, 167, 38, 0.15)" : "#E8580024", color: isDarkMode ? "#FFA726" : "#E85800" },
          Low: { bgcolor: isDarkMode ? "rgba(255, 224, 130, 0.15)" : "#F2BF0024", color: isDarkMode ? "#FFE082" : "#F2BF00" },
        };
        return (
          <Chip
            label={params.value}
            size="small"
            sx={{
              bgcolor: severityStyles[params.value]?.bgcolor || "#f5f5f5",
              color: severityStyles[params.value]?.color || "#666666",
              height: "20px",
              borderRadius: "4px",
              position: "relative",
              fontWeight: 600,
              p: 1.5,
              pr: 0,
              cursor: "pointer",
              "&:hover": {
                cursor: "pointer",
              },
              "&::before": {
                content: '""',
                position: "absolute",
                left: 8,
                top: "50%",
                transform: "translateY(-50%)",
                width: 8,
                height: 8,
                bgcolor: severityStyles[params.value]?.color || "#666666",
                borderRadius: "50%",
              },
              "& .MuiChip-label": { px: 1 },
            }}
          />
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "accepted_count",
      headerName: "Risk Accepted",
      maxWidth: 150,
      cellRenderer: (params: any) =>
        params.value > 0 ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, pt: 1 }}>
            <img src={Exclamation} alt="exclamation" height="20" />
            <Typography>{params.value}</Typography>
          </Box>
        ) : (
          <img
            src={AcceptedRisk_False}
            alt="warning"
            style={{ height: "20px" }}
          />
        ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "compliance_count",
      headerName: "Assets",
      width: 200,
      cellRenderer: (params: any) => {
        const passedCount = params.data.passed_asset_count;
        const compliance_count = params.data.total_Count;
        const rawValue = params.value || 0;
        const data = params.data;
        const progressValue = Number(rawValue.toFixed(2));
        const STATUS_CONFIG = {
          passed_asset_count: { label: "Pass", icon: True },
          failed_asset_count: { label: "Fail", icon: False },
          not_applicable_asset_count: {
            label: "Not Applicable",
            icon: Not_Applicable,
          },
        };
        const availableStatuses = Object.entries(STATUS_CONFIG)
          .filter(([key]) => data[key] != null && data[key] > 0)
          .map(([key, config]) => ({
            ...config,
            count: data[key],
            key,
          }));

        const total = availableStatuses.reduce((sum, s) => sum + s.count, 0);
        const passed = data.passed_asset_count || 0;
        const passPercent =
          total > 0 ? ((passed / total) * 100).toFixed(2) : "0.00";

        const tooltipContent =
          availableStatuses.length > 0 ? (
            <Box sx={{ p: 1, width: 200 }}>
              {availableStatuses.map((status) => (
                <Box
                  key={status.key}
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
                >
                  <img
                    src={status.icon}
                    alt={status.label}
                    style={{ width: 20, height: 20 }}
                  />
                  <Typography
                    variant="body2"
                    fontWeight={500}
                    sx={{ flexGrow: 1, color: "#000" }}
                  >
                    {status.label}
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ color: "#000" }}>
                    {status.count}
                  </Typography>
                </Box>
              ))}
            </Box>
          ) : (
            <Box sx={{ p: 1 }}>
              <Typography variant="body2" sx={{ color: "#000" }}>No data available</Typography>
            </Box>
          );

        return (
          <Tooltip
            title={tooltipContent}
            arrow
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: "preventOverflow",
                    options: {
                      boundary: "window",
                    },
                  },
                ],
              },
              tooltip: {
                sx: {
                  backgroundColor: "#fff",
                  color: "#000",
                  border: "1px solid #ddd",
                  boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                  fontSize: "14px",
                },
              },
              arrow: {
                sx: {
                  color: "#fff",
                },
              },
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                }}
              >
                <Typography variant="caption">
                  {`${passedCount}/${compliance_count} (${progressValue}%)`}
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={progressValue}
                sx={{
                  height: 6,
                  borderRadius: 3,
                  bgcolor: "#f5f5f5",
                  "& .MuiLinearProgress-bar": {
                    bgcolor:
                      progressValue >= 70
                        ? "#4caf50"
                        : progressValue >= 40
                          ? "#ff9800"
                          : "#f44336",
                  },
                }}
              />
            </Box>
          </Tooltip>
        );
      },
    },
  ], [uniqueBenchmarks, uniqueSeverities, isDarkMode, applyBenchmarkFilter, applySeverityFilter]);

  const adminRequestsColumnDefs: ColDef[] = useMemo(() => [
    {
      field: "id",
      headerName: "#",
      width: 55,
      maxWidth: 60,
      minWidth: 45,
      filter: false,
      sortable: false,
      suppressMenu: true,
      valueGetter: (params: any) => params.node.rowIndex + 1,
    },
    {
      field: "parameter_name",
      headerName: "Recommendation / Risk",
      flex: 1.2,
      minWidth: 200,
      valueGetter: (params: any) =>
        params.data?.parameter_name ||
        params.data?.param_name ||
        params.data?.parameter ||
        "N/A",
      cellRenderer: (params: any) => (
        <Tooltip title={params.value || ""}>
          <Typography
            noWrap
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: "13px",
              fontWeight: 500,
            }}
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
      cellStyle: { display: "flex", alignItems: "center" },
    },
    {
      field: "device_name",
      headerName: "Device / Host",
      flex: 0.8,
      minWidth: 110,
      valueGetter: (params: any) =>
        params.data?.device_name ||
        params.data?.host_name ||
        params.data?.device_hostname ||
        params.data?.ip ||
        params.data?.device_id ||
        "N/A",
      cellStyle: { display: "flex", alignItems: "center" },
    },
    {
      field: "requested_by_email",
      headerName: "Requested By",
      flex: 1,
      minWidth: 150,
      valueGetter: (params: any) =>
        params.data?.requested_by_email ||
        params.data?.organization_email ||
        params.data?.user_name ||
        params.data?.first_name ||
        params.data?.requested_by_name ||
        (params.data?.requested_by && !params.data?.requested_by.includes("-")
          ? params.data?.requested_by
          : "User"),
      cellStyle: { display: "flex", alignItems: "center" },
    },
    {
      field: "accepted_for_days",
      headerName: "Validity (Days)",
      width: 115,
      minWidth: 110,
      valueGetter: (params: any) =>
        params.data?.accepted_for_days || params.data?.validity_days || 60,
      cellRenderer: (params: any) => (
        <Chip
          label={`${params.value} Days`}
          size="small"
          sx={{
            fontWeight: 600,
            fontSize: "12px",
            bgcolor: isDarkMode ? "rgba(255, 255, 255, 0.08)" : "#f0f2f5",
          }}
        />
      ),
      cellStyle: { display: "flex", alignItems: "center" },
    },
    {
      field: "date_requested",
      headerName: "Requested Date",
      width: 150,
      minWidth: 145,
      suppressMenu: true,
      valueGetter: (params: any) =>
        params.data?.date_requested ||
        params.data?.created_at ||
        params.data?.time ||
        "-",
      cellRenderer: (params: any) => {
        if (!params.value || params.value === "-") return "-";
        try {
          const date = new Date(params.value);
          if (isNaN(date.getTime())) return params.value;
          return date.toLocaleString("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          });
        } catch {
          return params.value;
        }
      },
      cellStyle: { display: "flex", alignItems: "center" },
    },
    {
      field: "comments",
      headerName: "Comment",
      flex: 1,
      minWidth: 130,
      valueGetter: (params: any) =>
        params.data?.comments || params.data?.comment || "-",
      cellRenderer: (params: any) => (
        <Tooltip title={params.value || ""}>
          <Typography
            noWrap
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: "13px",
              color: "text.secondary",
            }}
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
      cellStyle: { display: "flex", alignItems: "center" },
    },
    {
      field: "requested_action",
      headerName: "Requested Action",
      width: 140,
      minWidth: 135,
      suppressMenu: true,
      valueGetter: (params: any) =>
        params.data?.requested_action || params.data?.action || "-",
      cellRenderer: (params: any) => {
        const val = params.value;
        if (!val || val === "-") return "-";
        const isRemove =
          String(val).toLowerCase().includes("remove") ||
          String(val).toLowerCase().includes("revoke");
        return (
          <Chip
            label={val}
            size="small"
            sx={{
              fontWeight: 600,
              fontSize: "12px",
              bgcolor: isRemove
                ? isDarkMode
                  ? "rgba(211, 47, 47, 0.15)"
                  : "#FFEBEE"
                : isDarkMode
                ? "rgba(25, 118, 210, 0.15)"
                : "#E3F2FD",
              color: isRemove
                ? isDarkMode
                  ? "#FF8A80"
                  : "#C62828"
                : isDarkMode
                ? "#90CAF9"
                : "#1565C0",
            }}
          />
        );
      },
      cellStyle: { display: "flex", alignItems: "center" },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 160,
      minWidth: 160,
      filter: false,
      sortable: false,
      suppressMenu: true,
      cellRenderer: (params: any) => {
        const id = params.data?.id ?? params.data?.whitelist_id;
        const status = (
          params.data?.approval_status ||
          params.data?.status ||
          "Pending"
        )
          .toString()
          .toLowerCase();
        const isPending =
          !status.includes("approv") &&
          !status.includes("reject") &&
          status !== "1" &&
          status !== "2";

        if (!isPending) {
          return (
            <Typography
              variant="caption"
              sx={{ color: "text.disabled", fontStyle: "italic" }}
            >
              Action Completed
            </Typography>
          );
        }

        const isRowLoading = actionLoadingState?.id === String(id);
        const isApproveLoading = isRowLoading && actionLoadingState?.action === "approve";
        const isRejectLoading = isRowLoading && actionLoadingState?.action === "reject";
        const isAnyLoading = actionLoadingState !== null;

        const handleClick = (action: "approve" | "reject") => {
          if (isAnyLoading) return;
          handleApproveReject(String(id), action);
        };

        return (
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Button
              size="small"
              disabled={isApproveLoading}
              onClick={() => handleClick("approve")}
              sx={{
                bgcolor: "#2e7d32",
                color: "#ffffff",
                fontSize: "11px",
                fontWeight: 600,
                textTransform: "none",
                height: "26px",
                minWidth: "70px",
                borderRadius: "5px",
                boxShadow: "none",
                px: 1.2,
                py: 0.3,
                transition: "all 0.15s ease-in-out",
                "&:hover": {
                  bgcolor: "#1b5e20",
                  color: "#ffffff",
                  boxShadow: "none",
                },
                "&:active": {
                  bgcolor: "#144617",
                },
                "&.Mui-disabled": {
                  bgcolor: "#2e7d32",
                  color: "#ffffff",
                  opacity: 0.85,
                },
              }}
            >
              {isApproveLoading ? (
                <CircularProgress size={14} thickness={5} sx={{ color: "#ffffff" }} />
              ) : (
                "Approve"
              )}
            </Button>
            <Button
              size="small"
              disabled={isRejectLoading}
              onClick={() => handleClick("reject")}
              sx={{
                bgcolor: "transparent",
                border: `1px solid ${isDarkMode ? "#ff4d4f" : "#d32f2f"}`,
                color: isDarkMode ? "#ff4d4f" : "#d32f2f",
                fontSize: "11px",
                fontWeight: 600,
                textTransform: "none",
                height: "26px",
                minWidth: "65px",
                borderRadius: "5px",
                boxShadow: "none",
                px: 1.2,
                py: 0.3,
                transition: "all 0.15s ease-in-out",
                "&:hover": {
                  bgcolor: isDarkMode ? "rgba(255, 77, 79, 0.15)" : "rgba(211, 47, 47, 0.08)",
                  borderColor: isDarkMode ? "#ff7875" : "#c62828",
                  color: isDarkMode ? "#ff7875" : "#c62828",
                  boxShadow: "none",
                },
                "&:active": {
                  bgcolor: isDarkMode ? "rgba(255, 77, 79, 0.25)" : "rgba(211, 47, 47, 0.15)",
                },
                "&.Mui-disabled": {
                  bgcolor: "transparent",
                  borderColor: isDarkMode ? "#ff4d4f" : "#d32f2f",
                  color: isDarkMode ? "#ff4d4f" : "#d32f2f",
                  opacity: 0.85,
                },
              }}
            >
              {isRejectLoading ? (
                <CircularProgress size={14} thickness={5} sx={{ color: isDarkMode ? "#ff4d4f" : "#d32f2f" }} />
              ) : (
                "Reject"
              )}
            </Button>
          </Box>
        );
      },
      cellStyle: { display: "flex", alignItems: "center" },
    },
  ], [isDarkMode, actionLoadingState]);

  const handleSeeDetailsClick = useCallback(() => {
    setIsSeeDetailsOpen(true);
  }, []);

  // No need for hardcoded rowData as we're using the API response data

  const [headerDetails, setHeaderDetails] = useState<any>(null);

  useEffect(() => {
    if (selectedRiskDetails?.id) {
      setHeaderDetails(null);
      const fetchHeaderDetails = async () => {
        try {
          const response = await axiosInstance.get(
            `securityscan/control-details/${selectedRiskDetails.id}`
          );
          if (response.data?.data) {
            setHeaderDetails(response.data.data);
          }
        } catch (error) {
          console.error("Error fetching header details:", error);
        }
      };
      fetchHeaderDetails();
    } else {
      setHeaderDetails(null);
    }
  }, [selectedRiskDetails?.id, trigger]);

  const drawerHeader = () => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          borderBottom: "1px solid #E0E0E0",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",

            pb: 1,
          }}
        >
          <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: 600, maxWidth: "95%" }}>
            {headerDetails?.normalized_name ||
              selectedRiskDetails?.param_name ||
              selectedRiskDetails?.parameter ||
              selectedRiskDetails?.paramter ||
              "Risk Details"}
          </Typography>
          {!isSeeDetailsOpen && (
            <Button
              variant="outlined"
              sx={{
                mr: "45px",
                color: theme.palette.mode === "dark" ? "#fff" : "#0F02C3",
                borderColor: theme.palette.mode === "dark" ? "#fff" : "#0F02C3",
              }}
              onClick={handleSeeDetailsClick}
            >
              Details
            </Button>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            px: 2,
            pb: 2,
          }}
        >
          {(headerDetails || selectedRiskDetails) && (() => {
            const sev = headerDetails?.severity || selectedRiskDetails?.highest_priority || selectedRiskDetails?.vulnerability || "Critical";
            const sevBg = sev === "Critical" ? (isDarkMode ? "rgba(255, 61, 61, 0.18)" : "#67000424") : sev === "High" ? (isDarkMode ? "rgba(255, 107, 107, 0.15)" : "#A7000F24") : sev === "Medium" ? (isDarkMode ? "rgba(255, 167, 38, 0.15)" : "#E8580024") : (isDarkMode ? "rgba(255, 224, 130, 0.15)" : "#F2BF0024");
            const sevColor = sev === "Critical" ? (isDarkMode ? "#FF3D3D" : "#670004") : sev === "High" ? (isDarkMode ? "#FF6B6B" : "#A7000F") : sev === "Medium" ? (isDarkMode ? "#FFA726" : "#E85800") : (isDarkMode ? "#FFE082" : "#F2BF00");
            return (
              <>
                <Chip
                  label={sev}
                  size="small"
                  sx={{
                    bgcolor: sevBg,
                    color: sevColor,
                    height: "20px",
                    borderRadius: "4px",
                    position: "relative",
                    fontWeight: 600,
                    p: 1.5,
                    pl: 2,
                    cursor: "pointer",
                    "&:hover": {
                      cursor: "pointer",
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      left: 8,
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: 8,
                      height: 8,
                      bgcolor: sevColor,
                      borderRadius: "50%",
                    },
                    "& .MuiChip-label": { px: 1 },
                  }}
                />
                {headerDetails?.type && (
                  <Tooltip
                    arrow
                    title={
                      headerDetails?.type === "Automated"
                        ? "This recommendation can be analysed automatically. No Manual intervention required."
                        : "This recommendation should be reviewed manually."
                    }
                    slotProps={{
                      popper: {
                        sx: {
                          "& .MuiTooltip-tooltip": {
                            backgroundColor: isDarkMode ? "#2d3748" : "#fff",
                            color: isDarkMode ? "#f7fafc" : "#000",
                            fontSize: "0.75rem",
                            border: `1px solid ${isDarkMode ? "#4a5568" : "#ddd"}`,
                            boxShadow: 2,
                          },
                          "& .MuiTooltip-arrow": {
                            color: isDarkMode ? "#2d3748" : "#fff",
                          },
                        },
                      },
                    }}
                  >
                    <Chip
                      label={headerDetails.type}
                      size="small"
                      sx={{
                        color: isDarkMode ? "#90CAF9" : "#2B335F",
                        bgcolor: isDarkMode ? "rgba(144, 202, 249, 0.16)" : "rgba(43, 51, 95, 0.08)",
                        minHeight: 24,
                        borderRadius: "4px",
                        fontWeight: 600,
                        cursor: "pointer",
                        pointerEvents: "auto",
                        "&:hover": {
                          cursor: "pointer",
                        },
                        "& .MuiChip-label": {
                          cursor: "pointer",
                          pointerEvents: "auto",
                        },
                      }}
                    />
                  </Tooltip>
                )}
              </>
            );
          })()}
          <Divider orientation="vertical" flexItem />
          <Typography variant="caption" color="text.secondary" sx={{ mx: 1 }}>
            Tags:
          </Typography>
          {headerDetails?.tags?.default
            ?.slice(0, 3)
            .map((tag: string, index: number) => {
              const displayTag = tag.length > 10 ? `${tag.substring(0, 10)}...` : tag;
              const tagLower = tag.toLowerCase();
              const tagBg = tagLower === "ssh" ? (isDarkMode ? "rgba(74, 222, 128, 0.18)" : "#0183191A") : tagLower === "https" ? (isDarkMode ? "rgba(251, 146, 60, 0.18)" : "#894B001A") : tagLower === "authentication" ? (isDarkMode ? "rgba(56, 189, 248, 0.18)" : "#0485C21A") : (isDarkMode ? "rgba(74, 222, 128, 0.18)" : "#0183191A");
              const tagColor = tagLower === "ssh" ? (isDarkMode ? "#4ADE80" : "#018319") : tagLower === "https" ? (isDarkMode ? "#FB923C" : "#894B00") : tagLower === "authentication" ? (isDarkMode ? "#38BDF8" : "#0485C2") : (isDarkMode ? "#4ADE80" : "#018319");
              return (
                <Tooltip
                  key={index}
                  title={tag.length > 10 ? tag : ""}
                  arrow
                  placement="top"
                >
                  <Chip
                    label={displayTag}
                    size="small"
                    sx={{
                      bgcolor: tagBg,
                      color: tagColor,
                      height: "20px",
                      borderRadius: "4px",
                      fontWeight: 600,
                      cursor: "pointer",
                      "&:hover": {
                        cursor: "pointer",
                      },
                    }}
                  />
                </Tooltip>
              );
            })}

          {headerDetails?.tags?.default?.length > 3 && (
            <Tooltip
              title={headerDetails.tags.default.slice(3).join(", ")}
              arrow
              placement="top"
            >
              <Chip
                label={`+${headerDetails.tags.default.length - 3}`}
                size="small"
                sx={{
                  bgcolor: isDarkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0",
                  color: isDarkMode ? "#E2E8F0" : "#424242",
                  height: "20px",
                  borderRadius: "4px",
                  fontWeight: 600,
                  cursor: "pointer",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              />
            </Tooltip>
          )}
        </Box>
      </Box>
    );
  };

  const riskHistoryDrawerHeader = () => {
    return null;
  };
  const dispatch = useDispatch();

  const handleScheduleRowClick = useCallback((rowData: any) => {
    if (!rowData) return;
    setSelectedRiskDetails(rowData);
    setOpen(true);
    // Same as cloud scan summary / Security Posture: Details tab needs the
    // row's control_type in redux or cloud controls-by-parameter stays empty.
    const rowId = rowData?.id ?? rowData?.parameter_name_id;
    if (rowId) {
      dispatch(setSelectedRowID(String(rowId)));
    }
    if (rowData?.control_type) {
      const controlType = String(rowData.control_type);
      dispatch(setSelectedControlType(controlType));
      dispatch(setButtonSelected(controlType.split(",")[0].trim().toLowerCase()));
      dispatch(setCategorySelected("Benchmark"));
    }
  }, [dispatch]);

  const handleTimelineClick = useCallback((rowData: any) => {
    setSelectedRiskHistory(rowData);
    setIsRiskDrawerOpen(true);
  }, []);

  const handleRiskDrawerClose = useCallback(() => {
    setIsRiskDrawerOpen(false);
  }, []);

  const handlleSeeDetailsClose = useCallback(() => {
    setIsSeeDetailsOpen(false);
  }, []);

  const getBenchmarks = (benchmark: any): string[] => {
    if (Array.isArray(benchmark)) return benchmark;
    if (typeof benchmark === "string") return benchmark.split(",");
    return [];
  };

  const formatDate = (input: string | number | Date): string => {
    const date = new Date(input);
    const pad = (n: number) => String(n).padStart(2, "0");

    const day = pad(date.getDate());
    const month = date.toLocaleString("en-US", { month: "long" }); // e.g., August
    const year = date.getFullYear();
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <Box sx={{ height: "calc(100vh - 112px)", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <Card
        sx={{
          p: 2,
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: 2,
          flexShrink: 0,
        }}
      >
        <Grid container spacing={2} alignItems="center">
          {/* Left side - Summary & Toggle */}
          <Grid item xs={6} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography
              variant="body1"
              sx={{ fontSize: "14px", fontWeight: 800 }}
            >
              SUMMARY
            </Typography>

            <ToggleButtonGroup
              value={activeTab}
              exclusive
              onChange={(_, nextTab) => {
                if (nextTab && nextTab !== activeTab) {
                  handleClearAdminSelection();
                  setActiveTab(nextTab);
                  setOpen(false);
                  setIsRiskDrawerOpen(false);
                  setIsSeeDetailsOpen(false);
                }
              }}
              size="small"
              sx={{
                height: "28px",
                "& .MuiToggleButton-root": {
                  fontSize: "12px",
                  fontWeight: 600,
                  textTransform: "none",
                  px: 1.5,
                  py: 0.25,
                  color: isDarkMode ? "#bbb" : "#555",
                  borderColor: isDarkMode ? "#444" : "#e0e0e0",
                  "&.Mui-selected": {
                    bgcolor: "#3A2ADA",
                    color: "#fff",
                    "&:hover": {
                      bgcolor: "#2e21b0",
                    },
                  },
                },
              }}
            >
              <ToggleButton value="risk_acceptance">
                Risk Acceptance
              </ToggleButton>
              {isAdmin && (
                <ToggleButton value="admin_requests">
                  Admin Requests
                </ToggleButton>
              )}
            </ToggleButtonGroup>
          </Grid>

          <Grid item xs={6}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 3,
                justifyContent: "flex-end",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  sx={{ fontSize: "13px", fontWeight: "400", color: isDarkMode ? "#98A2B3" : "#667085" }}
                >
                  Total:
                </Typography>
                <Typography fontWeight="bold" sx={{ fontSize: "14px", color: isDarkMode ? "#F9FAFB" : "inherit" }}>
                  {parseInt(summaryDeatils.Critical || 0) +
                    parseInt(summaryDeatils.High || 0) +
                    parseInt(summaryDeatils.Medium || 0) +
                    parseInt(summaryDeatils.Low || 0)}
                </Typography>
              </Box>
              <Divider orientation="vertical" flexItem />
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  sx={{ fontSize: "13px", fontWeight: "400", color: isDarkMode ? "#98A2B3" : "#667085" }}
                >
                  Critical:
                </Typography>
                <Typography
                  fontWeight="600"
                  sx={{ fontSize: "14px", color: isDarkMode ? "#FF3D3D" : "#670004" }}
                >
                  {summaryDeatils.Critical || 0}
                </Typography>
              </Box>
              <Divider orientation="vertical" flexItem />
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  sx={{ fontSize: "13px", fontWeight: "400", color: isDarkMode ? "#98A2B3" : "#667085" }}
                >
                  High:
                </Typography>
                <Typography
                  fontWeight="600"
                  sx={{ fontSize: "14px", color: isDarkMode ? "#FF6B6B" : "#A7000F" }}
                >
                  {summaryDeatils.High || 0}
                </Typography>
              </Box>
              <Divider orientation="vertical" flexItem />
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  sx={{ fontSize: "13px", fontWeight: "400", color: isDarkMode ? "#98A2B3" : "#667085" }}
                >
                  Medium:
                </Typography>
                <Typography
                  fontWeight="600"
                  sx={{ fontSize: "14px", color: isDarkMode ? "#FFA726" : "#E85800" }}
                >
                  {summaryDeatils.Medium || 0}
                </Typography>
              </Box>
              <Divider orientation="vertical" flexItem />
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  sx={{ fontSize: "13px", fontWeight: "400", color: isDarkMode ? "#98A2B3" : "#667085" }}
                >
                  Low:
                </Typography>
                <Typography
                  fontWeight="600"
                  sx={{ fontSize: "14px", color: isDarkMode ? "#FFE082" : "#F2BF00" }}
                >
                  {summaryDeatils.Low || 0}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Card>
      {activeTab === "risk_acceptance" ? (
        <Grid container spacing={1} sx={{ mt: 1, flex: 1, minHeight: 0, height: "100%" }}>
          <Grid item xs={8.8} sx={{ height: "100%" }}>
            <Card
              sx={{
                boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
                borderRadius: 2,
                height: "100%",
              }}
            >
              <AgGridTable
                key="risk-acceptance-grid"
                columnDefs={columnDefs}
                height={"100%"}
                data={gridData}
                showSearch
                onRowClick={handleScheduleRowClick}
                isLoading={loading}
                searchPlaceholder={"Search Recommendation"}
              />
            </Card>
          </Grid>
          <Grid item xs={3.2} sx={{ height: "100%" }}>
            <Card
              className="scroll"
              sx={{
                p: 2,
                boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
                borderRadius: 2,
                height: "100%",
                overflowY: "auto",
              }}
            >
              <Typography
                variant="body1"
                fontWeight="bold"
                fontSize="14px"
                mb={2}
              >
                Risk History
              </Typography>
              <Divider orientation="horizontal" sx={{ mb: 2 }} />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  position: "relative",
                  "& .timeline-item": {
                    display: "flex",
                    gap: 2,
                    position: "relative",
                    paddingBottom: 3,
                    zIndex: 1,
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      left: 4.5,
                      top: 10,
                      bottom: 20,
                      height: "100%",
                      width: 2,
                      backgroundColor: isDarkMode ? "#393E4B" : "#D3D2E3",
                    },
                  },
                }}
              >
                {isHistoryLoading ? (
                  <Box>
                    <SkeletonLoader
                      count={Math.floor(window.innerHeight / 45)}
                      styles={{ height: 20 }}
                    />
                  </Box>
                ) : riskHistoryData.length > 0 ? (
                  riskHistoryData.map((item, index) => (
                    <Box key={index} className="timeline-item">
                      <Box
                        sx={{
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          bgcolor: "#3A2ADA",
                          zIndex: 2,
                          boxShadow: "0px 2px 4px rgba(58, 42, 218, 0.25)",
                          mt: 1,
                        }}
                      />
                      <Box
                        sx={{ width: "100%", cursor: "pointer" }}
                        onClick={() => handleTimelineClick(item)}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            mb: 1,
                          }}
                        >
                          <Avatar
                            src={item.image_base64 || ""}
                            alt={`${item.first_name} ${item.last_name}`}
                            sx={{
                              width: 32,
                              height: 32,
                              fontSize: "12px",
                              zIndex: 2,
                              boxShadow: "0px 2px 4px rgba(58, 42, 218, 0.25)",
                            }}
                          >
                            {!item.image_base64 &&
                              (item.first_name?.charAt(0) || "U")}
                          </Avatar>
                          <Box>
                            <Typography
                              fontSize="14px"
                              color="primary"
                              fontWeight={600}
                            >
                              {item.time ? formatDate(item.time) : "N/A"}
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={{ ml: 0 }}>
                          <Typography
                            variant="body2"
                            fontWeight="600"
                            fontSize="13px"
                            mb={1}
                          >
                            {item.parameter}
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              flexWrap: "wrap",
                            }}
                          >
                            {(() => {
                              const vul = item.vulnerability;
                              const vulBg = vul === "Critical" ? (isDarkMode ? "rgba(255, 61, 61, 0.18)" : "#67000424") : vul === "High" ? (isDarkMode ? "rgba(255, 107, 107, 0.15)" : "#A7000F24") : vul === "Medium" ? (isDarkMode ? "rgba(255, 167, 38, 0.15)" : "#E8580024") : (isDarkMode ? "rgba(255, 224, 130, 0.15)" : "#F2BF0024");
                              const vulColor = vul === "Critical" ? (isDarkMode ? "#FF3D3D" : "#670004") : vul === "High" ? (isDarkMode ? "#FF6B6B" : "#A7000F") : vul === "Medium" ? (isDarkMode ? "#FFA726" : "#E85800") : (isDarkMode ? "#FFE082" : "#F2BF00");
                              return (
                                <Chip
                                  label={vul}
                                  size="small"
                                  sx={{
                                    bgcolor: vulBg,
                                    color: vulColor,
                                    height: "20px",
                                    borderRadius: "4px",
                                    position: "relative",
                                    fontWeight: 600,
                                    p: 1.5,
                                    pl: 2,
                                    cursor: "pointer",
                                    "&:hover": {
                                      cursor: "pointer",
                                    },
                                    "&::before": {
                                      content: '""',
                                      position: "absolute",
                                      left: 8,
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      width: 8,
                                      height: 8,
                                      bgcolor: vulColor,
                                      borderRadius: "50%",
                                    },
                                    "& .MuiChip-label": { px: 1 },
                                  }}
                                />
                              );
                            })()}
                            <Divider
                              orientation="vertical"
                              flexItem
                              sx={{ height: "15px", mt: 0.5 }}
                            />
                            {getBenchmarks(item?.benchmark).includes("SPARK") && (
                              <img
                                src={isDarkMode ? spark_dark : sparkLogo}
                                alt="spark"
                                height="24"
                              />
                            )}
                            {getBenchmarks(item?.benchmark).includes("CIS") && (
                              <img
                                src={isDarkMode ? cis_dark : csiLogo}
                                alt="cis"
                                height="24"
                              />
                            )}
                            {getBenchmarks(item?.benchmark).includes("NIST") && (
                              <img
                                src={isDarkMode ? nist_dark : nistLogo}
                                alt="nist"
                                height="12"
                              />
                            )}
                          </Box>
                        </Box>
                        <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                          <Chip
                            label={`${item.total_devices} Assets`}
                            size="small"
                            sx={{
                              background:
                                "linear-gradient(to right, #A3B4D3, #667A98)",
                              color: "#FFFFFF",
                              height: "20px",
                              borderRadius: "4px",
                              position: "relative",
                              fontWeight: 600,
                              p: 1.5,
                              pl: 0,
                              pr: 0,
                              cursor: "pointer",
                              "&:hover": {
                                cursor: "pointer",
                              },
                              "& .MuiChip-label": { px: 1 },
                            }}
                          />
                          <Chip
                            label={`${item.accepted_devices} Accepted`}
                            size="small"
                            sx={{
                              background:
                                "linear-gradient(to right, #F63E57, #CD0C0D)",
                              color: "#fff",
                              height: "20px",
                              borderRadius: "4px",
                              position: "relative",
                              fontWeight: 600,
                              p: 1.5,
                              pl: 0,
                              pr: 0,
                              cursor: "pointer",
                              "&:hover": {
                                cursor: "pointer",
                              },
                              "& .MuiChip-label": { px: 1 },
                            }}
                          />
                          <Chip
                            label={`${item.notaccepted_devices} Removed`}
                            size="small"
                            sx={{
                              background:
                                "linear-gradient(to right, #6BBD0E, #038C12)",
                              color: "#fff",
                              height: "20px",
                              borderRadius: "4px",
                              position: "relative",
                              fontWeight: 600,
                              p: 1.5,
                              pl: 0,
                              pr: 0,
                              cursor: "pointer",
                              "&:hover": {
                                cursor: "pointer",
                              },
                              "& .MuiChip-label": { px: 1 },
                            }}
                          />
                        </Box>
                        <Box
                          sx={{
                            mt: 1.5,
                            p: 1.25,
                            bgcolor: isDarkMode ? "rgba(255, 255, 255, 0.05)" : "#F2F4F7",
                            borderRadius: "6px",
                            border: `1px solid ${isDarkMode ? "rgba(255, 255, 255, 0.1)" : "#EAECF0"}`,
                            display: "flex",
                            flexDirection: "column",
                            gap: 0.5,
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              fontSize: "12px",
                              color: isDarkMode ? "#D0D5DD" : "#344054",
                              lineHeight: 1.4,
                            }}
                          >
                            <Box component="span" sx={{ fontWeight: 700 }}>
                              Requested By:{" "}
                            </Box>
                            {getRequestedByInfo(item)}
                          </Typography>
                          {isPendingRiskHistory(item) ? (
                            <Typography
                              variant="caption"
                              sx={{
                                fontSize: "12px",
                                color: isDarkMode ? "#D0D5DD" : "#344054",
                                lineHeight: 1.4,
                              }}
                            >
                              <Box component="span" sx={{ fontWeight: 700 }}>
                                Approval Status:{" "}
                              </Box>
                              Pending
                            </Typography>
                          ) : shouldShowRejectedBy(item) ? (
                            <Typography
                              variant="caption"
                              sx={{
                                fontSize: "12px",
                                color: isDarkMode ? "#D0D5DD" : "#344054",
                                lineHeight: 1.4,
                              }}
                            >
                              <Box component="span" sx={{ fontWeight: 700 }}>
                                Rejected By:{" "}
                              </Box>
                              {getRejectedByInfo(item)}
                            </Typography>
                          ) : (
                            <Typography
                              variant="caption"
                              sx={{
                                fontSize: "12px",
                                color: isDarkMode ? "#D0D5DD" : "#344054",
                                lineHeight: 1.4,
                              }}
                            >
                              <Box component="span" sx={{ fontWeight: 700 }}>
                                Approved By:{" "}
                              </Box>
                              {getApprovedByInfo(item)}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  ))
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100px",
                    }}
                  >
                    <Typography color="text.secondary">
                      No risk history data available
                    </Typography>
                  </Box>
                )}
              </Box>
            </Card>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={1} sx={{ mt: 1, flex: 1, minHeight: 0, height: "100%" }}>
          <Grid item xs={12} sx={{ height: "100%" }}>
            <Card
              sx={{
                boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
                borderRadius: 2,
                height: "100%",
              }}
            >
              <AgGridTable
                key="admin-requests-grid"
                gridRef={adminGridRef}
                columnDefs={adminRequestsColumnDefs}
                height={"100%"}
                data={adminRequests}
                showSearch
                isLoading={isAdminRequestsLoading}
                searchPlaceholder={"Search Admin Whitelist Requests"}
                isRowSelectable={true}
                checkboxSelection={true}
                headerCheckboxSelection={true}
                headerCheckboxSelectionCurrentPageOnly={true}
                onSelectionChange={handleAdminSelectionChange}
                gridOptions={adminGridOptions}
                headerActions={
                  selectedAdminRequests.length > 0 ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 600,
                          color: isDarkMode ? "#90CAF9" : "#1565C0",
                          fontSize: "13px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {selectedAdminRequests.length} Selected
                      </Typography>
                      <Button
                        size="small"
                        variant="contained"
                        onClick={(e) => setBulkActionAnchorEl(e.currentTarget)}
                        disabled={isBulkActionLoading}
                        endIcon={isBulkActionLoading ? <CircularProgress size={14} sx={{ color: "#fff" }} /> : <KeyboardArrowDownIcon />}
                        sx={{
                          bgcolor: "#3A2ADA",
                          color: "#fff",
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "12px",
                          height: "30px",
                          borderRadius: "6px",
                          px: 1.5,
                          boxShadow: "none",
                          "&:hover": {
                            bgcolor: "#2E1FB8",
                            boxShadow: "none",
                          },
                        }}
                      >
                        Actions
                      </Button>
                      <Menu
                        anchorEl={bulkActionAnchorEl}
                        open={Boolean(bulkActionAnchorEl)}
                        onClose={() => setBulkActionAnchorEl(null)}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        PaperProps={{
                          sx: {
                            mt: 0.5,
                            borderRadius: "8px",
                            minWidth: "160px",
                            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                          },
                        }}
                      >
                        <MenuItem
                          onClick={() => handleBulkApproveReject("approve")}
                          sx={{ fontSize: 13, py: 0.5, minHeight: 32 }}
                        >
                          Approve
                        </MenuItem>
                        <MenuItem
                          onClick={() => handleBulkApproveReject("reject")}
                          sx={{
                            color: "error.main",
                            "&:hover": {
                              backgroundColor: "error.lighter",
                            },
                            fontSize: 13,
                            py: 0.5,
                            minHeight: 32,
                          }}
                        >
                          Reject
                        </MenuItem>
                      </Menu>
                    </Box>
                  ) : undefined
                }
              />
            </Card>
          </Grid>
        </Grid>
      )}
      <DrawerWrapper
        open={open}
        onClose={handleClose}
        body={
          <RiskDetailsDrawer
            selectedRisk={selectedRiskDetails}
            onAcceptSuccessRiskDetail={riskDetail}
            onAcceptSuccessRiskHistory={riskHistory}
            setIsSeeDetailsOpen={setIsSeeDetailsOpen}
          />
        }
        styles={{ width: "min(920px, 82vw)", padding: 0, margin: 0 }}
        header={drawerHeader()}
        bodySx={{ overflow: "hidden" }}
      />
      <DrawerWrapper
        open={isRiskDrawerOpen}
        onClose={handleRiskDrawerClose}
        body={
          <RiskHistoryDrawer
            selectedRow={selectedRiskHistory}
            title={selectedRiskHistory?.parameter || ""}
            severity={selectedRiskHistory?.vulnerability || "Critical"}
            benchmarks={
              Array.isArray(selectedRiskHistory?.benchmark)
                ? selectedRiskHistory?.benchmark
                : typeof selectedRiskHistory?.benchmark === "string"
                  ? selectedRiskHistory?.benchmark.split(",")
                  : ["SPARK", "CIS", "NIST"]
            }
            assetCount={selectedRiskHistory?.total_devices || 0}
            acceptedCount={selectedRiskHistory?.accepted_devices || 0}
            removedCount={selectedRiskHistory?.notaccepted_devices || 0}
            selectedRisk={selectedRiskHistory}
          />
        }
        styles={{ width: "min(920px, 82vw)", padding: 0, margin: 0 }}
        header={riskHistoryDrawerHeader()}
        bodySx={{ overflow: "hidden" }}
      />
      <DrawerWrapper
        open={isSeeDetailsOpen}
        onClose={handlleSeeDetailsClose}
        body={
          <SeeDetailsDrawer
            handlleSeeDetailsClose={handlleSeeDetailsClose}
            selectedRisk={selectedRiskDetails}
          />
        }
        styles={{ width: "min(920px, 82vw)", padding: 0, margin: 0 }}
        header={drawerHeader()}
      />
    </Box>
  );
};

export default RiskAcceptancePage;
